// extracted by mini-css-extract-plugin
export default {"page":"LoadingPage_page__bEPrk","header-image":"LoadingPage_header-image__Cf8x8","second-header":"LoadingPage_second-header__ZcGow","loader":"LoadingPage_loader__XMciC"};